module.exports = __webpack_public_path__ + "img/14a.1c6cb85c.png";